import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Telephone = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path
        d="M6.668 2.296c0-.184.15-.333.333-.333h7a1.666 1.666 0 0 1 1.667 1.666v9.333A1.666 1.666 0 0 1 14 14.63h-7a.333.333 0 1 1 0-.667h7a1 1 0 0 0 1-1V3.63a1 1 0 0 0-1-1h-7a.333.333 0 0 1-.333-.333ZM.334 1.962c0-.184.15-.333.333-.333h4.334c.184 0 .333.15.333.333v12.666c0 .184-.15.334-.333.334H.667a.333.333 0 0 1-.333-.334V1.962Zm.667.334v12h3.666v-12H1.001Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M7.334 4.296c0-.184.15-.333.333-.333h5.334c.184 0 .333.15.333.333V7.63c0 .185-.15.334-.333.334H7.667a.333.333 0 0 1-.333-.334V4.296Zm.667.334v2.666h4.666V4.63H8.001ZM11.334 9.962c0-.184.15-.333.333-.333h1.334a.333.333 0 1 1 0 .667h-1.334a.333.333 0 0 1-.333-.334ZM11.334 11.962c0-.184.15-.333.333-.333h1.334a.333.333 0 1 1 0 .667h-1.334a.333.333 0 0 1-.333-.334Z"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path d="M8 10.628a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z" />
    </svg>
  );
};

Telephone.category = 'product-category';

Telephone.displayName = 'Telephone';
